// src/components/AddEditStaffModal/components/SalaryInfoTab.js
import React from 'react';
import {
    Grid,
    Typography,
    FormControl,
    FormLabel,
    RadioGroup,
    Radio,
    Box,
} from '@material-ui/core';
import { CustomTextField } from '../../../Textfield';
import { RadioButton, StyledMenuItem } from './FormUI';
import RateCardModal from '../../RateCardModal';
import { FreeLancerIcon } from '../../../../assets/svg';
import CustomSwitch from '../../../Switch';

export default function SalaryInfoTab({
    isEdit,
    formik,
    handlers,
    salaryTypes,
    baseRateTypes,
    salaryTypeList,
    salaryCycleList,
    salaryCycleDayList,
    rateCardResponse,
    filteredBaseRateTypesList,
}) {
    return (
        <Grid container spacing={2}>
            <Grid item xs={12}>
                <FormControl
                    component="div"
                    style={{ marginBottom: 16, width: '100%' }}
                >
                    <FormLabel
                        component="div"
                        style={{
                            fontSize: 16,
                            fontWeight: 'bold',
                        }}
                    >
                        Salary Type
                    </FormLabel>
                    <RadioGroup
                        fullWidth={true}
                        style={{
                            display: 'flex',
                            flexDirection: 'row',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            marginLeft: 12,
                        }}
                        value={formik?.values?.salaryType ?? '4'}
                        name="salaryType"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                    >
                        {salaryTypeList?.map((item, i) => (
                            <RadioButton
                                value={item?.id}
                                control={
                                    <Radio
                                        color="primary"
                                        checked={
                                            formik?.values?.salaryType ==
                                            item?.id
                                        }
                                    />
                                }
                                label={
                                    <Box
                                        style={{
                                            display: 'flex',
                                            flexDirection: 'column',
                                            padding: 8,
                                            paddingLeft: 0,
                                        }}
                                    >
                                        <Typography
                                            variant="span"
                                            style={{
                                                fontSize: 14,
                                                fontWeight: 600,
                                            }}
                                        >
                                            {item?.name}
                                        </Typography>
                                        <Typography
                                            variant="span"
                                            style={{
                                                fontSize: 10,
                                                fontWeight: 400,
                                            }}
                                        >
                                            {item?.description}
                                        </Typography>
                                    </Box>
                                }
                            />
                        ))}
                    </RadioGroup>
                </FormControl>
            </Grid>
            <Grid item xs={12}>
                <FormLabel
                    component="div"
                    style={{
                        fontSize: 16,
                        fontWeight: 'bold',
                    }}
                >
                    Salary Cycle
                </FormLabel>
                <Grid container spacing={2}>
                    <Grid item xs={6}>
                        <CustomTextField
                            label="Cycle"
                            select
                            fullWidth={true}
                            value={formik?.values?.salaryCycle ?? ''}
                            name="salaryCycle"
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            defaultValue=""
                            style={{ margin: '10px 12px 12px 0' }}
                        >
                            {salaryCycleList?.length ? (
                                salaryCycleList?.map((type, index) => (
                                    <StyledMenuItem
                                        key={index}
                                        value={type.value}
                                    >
                                        {type.name}
                                    </StyledMenuItem>
                                ))
                            ) : (
                                <StyledMenuItem value={null}>
                                    No Data Found
                                </StyledMenuItem>
                            )}
                        </CustomTextField>
                    </Grid>
                    <Grid item xs={6}>
                        <CustomTextField
                            label="Day"
                            select
                            fullWidth={true}
                            value={formik?.values?.salaryCycleDay ?? ''}
                            name="salaryCycleDay"
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            defaultValue=""
                            style={{ margin: '10px 0 12px 0' }}
                        >
                            {salaryCycleDayList?.length ? (
                                salaryCycleDayList.map((type, index) => (
                                    <StyledMenuItem
                                        key={index}
                                        value={type.value}
                                    >
                                        {type.name}
                                    </StyledMenuItem>
                                ))
                            ) : (
                                <StyledMenuItem value={null}>
                                    No Data Found
                                </StyledMenuItem>
                            )}
                        </CustomTextField>
                    </Grid>
                </Grid>
            </Grid>
            <Grid item xs={12}>
                <FormLabel
                    component="div"
                    style={{
                        fontSize: 16,
                        fontWeight: 'bold',
                        marginBottom: 5,
                    }}
                >
                    Salary Amount
                </FormLabel>
                <Grid container spacing={2}>
                    <Grid item xs={6}>
                        <CustomTextField
                            fullWidth={true}
                            label="Opening Balance"
                            value={formik?.values?.openingBalance}
                            name="openingBalance"
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            error={
                                formik.touched.openingBalance &&
                                Boolean(formik.errors.openingBalance)
                            }
                            helperText={
                                formik.touched.openingBalance &&
                                formik.errors.openingBalance
                            }
                            style={{}}
                            disabled={isEdit}
                        />
                    </Grid>
                    <Grid item xs={6}>
                        {rateCardResponse?.rateCard &&
                        Object.keys(rateCardResponse?.rateCard)?.length ? (
                            <Box
                                style={{
                                    display: 'flex',
                                    flexDirection: 'row',
                                    alignItems: 'center',
                                    justifyContent: 'space-between',
                                    backgroundColor:
                                        'rgba(201, 204, 215, 0.16)',
                                    padding: '6px 14px',
                                    borderRadius: 8,
                                    marginBottom: 10,
                                }}
                            >
                                <Typography
                                    variant="span"
                                    style={{
                                        fontSize: 14,
                                        fontWeight: 400,
                                        color: '#263238',
                                    }}
                                >
                                    Custom Rate
                                </Typography>

                                <RateCardModal data={rateCardResponse} />
                            </Box>
                        ) : (
                            <Box
                                style={{
                                    display: 'flex',
                                    flexDirection: 'row',
                                    alignItems: 'center',
                                    justifyContent: 'space-between',
                                }}
                            >
                                <CustomTextField
                                    label="Base Rate Type"
                                    select
                                    fullWidth={true}
                                    value={formik?.values?.baseRateType ?? ''}
                                    name="baseRateType"
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    error={
                                        formik.touched.openingBalance &&
                                        Boolean(formik.errors.openingBalance)
                                    }
                                    helperText={
                                        formik.touched.openingBalance &&
                                        formik.errors.openingBalance
                                    }
                                    defaultValue=""
                                    style={{ margin: '0 12px 12px 0' }}
                                >
                                    {filteredBaseRateTypesList?.length ? (
                                        filteredBaseRateTypesList.map(
                                            (type, index) => (
                                                <StyledMenuItem
                                                    key={index}
                                                    value={type.id}
                                                >
                                                    {type.name}
                                                </StyledMenuItem>
                                            ),
                                        )
                                    ) : (
                                        <StyledMenuItem value={null}>
                                            No Data Found
                                        </StyledMenuItem>
                                    )}
                                </CustomTextField>
                                <CustomTextField
                                    fullWidth={true}
                                    label="Base Rate"
                                    name="baseRate"
                                    value={formik?.values?.baseRate}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    error={
                                        formik.touched.baseRate &&
                                        Boolean(formik.errors.baseRate)
                                    }
                                    helperText={
                                        formik.touched.baseRate &&
                                        formik.errors.baseRate
                                    }
                                    style={{ margin: '0 0 12px 0' }}
                                />
                            </Box>
                        )}
                    </Grid>
                </Grid>
            </Grid>

            <Grid item xs={6}>
                <FormLabel
                    component="div"
                    style={{
                        fontSize: 16,
                        fontWeight: 'bold',
                    }}
                >
                    Employment nature
                </FormLabel>
                <Box
                    style={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        marginBottom: '16px',
                        marginTop: 10,
                    }}
                >
                    <Typography
                        style={{
                            display: 'flex',
                            flexDirection: 'row',
                            alignItems: 'center',
                            color: '#14112d',
                        }}
                    >
                        <FreeLancerIcon
                            width={24}
                            height={24}
                            style={{
                                marginRight: '8px',
                            }}
                        />
                        FreeLancer
                    </Typography>
                    <CustomSwitch
                        checked={formik?.values?.freelancer}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={
                            formik.touched.freelancer &&
                            Boolean(formik.errors.freelancer)
                        }
                        helperText={
                            formik.touched.freelancer &&
                            formik.errors.freelancer
                        }
                        name="freelancer"
                    />
                </Box>
            </Grid>
        </Grid>
    );
}
